import styled, { css } from 'styled-components';
import { colors, media, layout } from '@prisjakt/ui-base';
import CountryFlagComponent from '@prisjakt/ui-country-flag';

type StockStatusWrapperProps = {
  toneDown: boolean;
  alignCenter: boolean;
};

export const StockStatusWrapper = styled.div<StockStatusWrapperProps>`
  width: 100%;
  flex: 0;
  display: flex;
  flex-direction: row;

  ${props =>
    props.toneDown &&
    css`
      svg path {
        fill: ${colors.lightGray2} !important;
      }
    `}

  ${props =>
    props.alignCenter &&
    css`
      justify-content: center;
      align-items: center;
    `}
`;

export const HideOnMobile = styled.div`
  ${media.smallOnly`display: none;`}
`;

export const HideOnDesktop = styled.div`
  ${media.mediumUp`display: none;`}
`;

export const CountryFlag = styled(CountryFlagComponent)`
  display: flex;
  flex: 1 0 auto;
  margin-right: ${layout.spacing.xSmall};
`;

export const HomeDeliveryIcon = styled.img`
  height: 20px;
  width: 20px;
  display: block;
`;
